import PropTypes from "prop-types";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DailyDataTable from "../DailyDataTable";

export default function DailyDataCalendar({ index }) {
  const { t, i18n } = useTranslation();
  const isLtr = i18n.language === "en";

  const today = new Date().toISOString().split("T")[0];
  const start = new Date();
  start.setDate(start.getDate() - 14);
  const startDateDefault = start.toISOString().split("T")[0];

  const [startDate, setStartDate] = useState(startDateDefault);
  const [endDate, setEndDate] = useState(today);
  const [dailyData, setDailyData] = useState([]);

  useEffect(() => {
    const filteredData = (index.index_data_ || []).filter((data) => {
      return data.date >= startDate && data.date <= endDate;
    });
    setDailyData(filteredData);
  }, [index.index_data_, startDate, endDate]);

  const convertToCSV = useCallback((data) => {
    const header = ["date", "price", "return"];
    const rows = data.map((row) => [row.date, row.price, row.return]);
    return [header, ...rows].map((e) => e.join(",")).join("\n");
  }, []);

  const downloadCSV = useCallback(
    (data) => {
      try {
        const csvContent = convertToCSV(data);
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute(
          "download",
          `${index.id}_daily_data_${startDate}_to_${endDate}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading CSV:", error);
      }
    },
    [convertToCSV]
  );

  const handleDownload = () => {
    downloadCSV(dailyData);
  };

  return (
    <>
      <div className="index-daily-calendar-wrapper" dir={isLtr ? "ltr" : "rtl"}>
        <label
          className="index-daily-calendar-label"
          htmlFor="start-date"
          aria-label={t("DailyDataCalendar.from_date")}
        >
          {t("DailyDataCalendar.from_date")}
        </label>
        <input
          id="start-date"
          type="date"
          value={startDate}
          className="index-daily-calendar-input"
          onChange={(e) => setStartDate(e.target.value)}
        />
        <label
          className="index-daily-calendar-label"
          htmlFor="end-date"
          aria-label={t("DailyDataCalendar.to_date")}
        >
          {t("DailyDataCalendar.to_date")}
        </label>
        <input
          id="end-date"
          type="date"
          value={endDate}
          className="index-daily-calendar-input"
          onChange={(e) => setEndDate(e.target.value)}
        />
        <button
          className="index-daily-calendar-button"
          onClick={handleDownload}
          aria-label={t("DailyDataTable.download_file")}
        >
          {t("DailyDataTable.download_file")}
        </button>
      </div>
      {dailyData.length > 0 && <DailyDataTable dailyData={dailyData} />}
    </>
  );
}

DailyDataCalendar.propTypes = {
  index: PropTypes.object.isRequired,
};
